<sc-master-detail [readOnly]="!manageCatalogPermitted" [data]="data" [selection]="[selected]" (selectionChanged)="onSelectionChanged($event)"
    (addEntry)="onAddEntry($event)" (deleteEntry)="onDeleteEntry($event)">

    <sc-padding [fitHeight]="true" *ngIf="selected !== articleSearchListEntry && manageCatalogPermitted" >
        <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
            <sc-title>{{ 'Catalog' | translate: ['erp.ui.catalog.title', translationService.language]}}
            </sc-title>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <sc-bordered-tile>
                <sc-padding>
                    <app-catalog-masterdata [catalog]="selected" [catalogAdminComponent]="this"></app-catalog-masterdata>
                </sc-padding>
            </sc-bordered-tile>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <sc-sub-title>{{ 'Structure' | translate: ['erp.ui.catalog.subtitle.structure', translationService.language]}}
                <sc-content-spacer [grow]="true"></sc-content-spacer>
                <button mat-stroked-button (click)="addRootNode()">
                    <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                    {{ 'Add' | translate: ['erp.ui.catalog.action.add-structurenode', translationService.language]}}
                </button>
            </sc-sub-title>
            <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
            <sc-flex-fitting-content [vertical]="true">
                <sc-bordered-tile [fitHeight]="true">
                    <sc-scroll-pane>
                        <sc-padding>
                            <app-catalog-structure [catalog]="selected" [catalogAdminComponent]="this"></app-catalog-structure>
                        </sc-padding>
                    </sc-scroll-pane>
                </sc-bordered-tile>
            </sc-flex-fitting-content>
        </sc-flex>
    </sc-padding>

    <sc-padding [fitHeight]="true" *ngIf="selected === articleSearchListEntry" >
      <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
          <sc-title>{{ 'Article Search' | translate: ['erp.ui.catalog.subtitle.article-search', translationService.language]}}</sc-title>
          <sc-content-spacer [vertical]="true"></sc-content-spacer>

          <sc-flex-fitting-content [vertical]="true">
            <sc-bordered-tile [fitHeight]="true">
                <sc-scroll-pane>
                    <sc-padding>
                      <app-catalog-article-search></app-catalog-article-search>
                    </sc-padding>
                </sc-scroll-pane>
            </sc-bordered-tile>
        </sc-flex-fitting-content>
      </sc-flex>
    </sc-padding>

</sc-master-detail>
